import { ReactNode } from 'react'

import { astraTwMerge } from '../Utilities/astraTwMerge'

type Props = {
    children: ReactNode
    className?: string
}

export const AstraCard = ({ children, className }: Props) => (
    <div className={astraTwMerge('rounded-xl border border-subtle bg-surface-base', className)}>{children}</div>
)
